var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJoinUseSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9671 25.0528C28.5889 27.1727 26.7404 29 24.5312 29C17.8646 29 11.1979 29 4.53125 29C2.32211 29 0.473647 27.1727 1.0954 25.0528C2.79952 19.2427 8.16992 15 14.5312 15C20.8926 15 26.263 19.2427 27.9671 25.0528Z",
    fill: "#FFA686"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5312,
    cy: 9,
    r: 9,
    fill: "#CFB2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinUseSvg);
export default __webpack_public_path__ + "static/media/join-use-svg.0f37036262138b279ba5362e799a4567.svg";
export { ForwardRef as ReactComponent };